export const DEBOUNCE_TIME = {
  BAITCHECKER_SEARCH_DELAY: 350,
};
